// extracted by mini-css-extract-plugin
export default {"table":"DataTableRemotePaging_table__Y2SH9"};